import {useEffect, useRef} from "react";
import {Route, BrowserRouter as Router, Routes} from "react-router-dom";
import AppWrapper from "./components/layout/AppWrapper";
import Layout from "./components/layout";
import {AddRequestPage, RequestList, CheckInformation, NoPage} from "./pages";
import {NotificationListener} from "./components/layout/NotificationListener";
import {
    CreateRequestProvider,
    NotificationProvider,
    useAuth,
} from "./context";

function PrivateRoute(props: {children: JSX.Element}) {
    return <NotificationProvider>
        <AppWrapper>
            <CreateRequestProvider>
                <NotificationListener/>
                {props.children}
            </CreateRequestProvider>
        </AppWrapper>
    </NotificationProvider>;
}

function MainRoutes() {
    return <Routes>
        <Route path="/" element={<CheckInformation/>} />
        <Route
            path="/add-request"
            element={<Layout><AddRequestPage/></Layout>}
        />
        <Route
            path="/request-list"
            element={<Layout><RequestList /></Layout>}
        />
        <Route path="/*" element={<NoPage/>}/>
    </Routes>;
}

function App() {
    const hasFetched = useRef(false);
    const {status} = useAuth();
    useEffect(function () {
        if (status === "authenticated" && !hasFetched.current) {
            hasFetched.current = true;
        }
        if (status === "unauthenticated") {
            hasFetched.current = false;
        }
    }, [status]);
    return <Router>
        <Routes>
            <Route path="/*" element={<PrivateRoute><MainRoutes/></PrivateRoute>}/>
        </Routes>
    </Router>;
}

export default App;
